import { styled } from 'baseui'

export const StyledLi = styled('li', ({ $theme }) => ({
  display: 'flex',
  gap: '.25rem',
  position: 'relative',
  listStyle: 'none',
  paddingLeft: '0.75rem',
  marginBottom: '.5rem',
  '::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: '5px',
    height: '5px',
    borderRadius: '50%',
    background: $theme.colors.grey,
  },
}))

export const StyledText = styled('p', ({ $theme }) => ({
  color: $theme.colors.textHeading,
}))
